import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';


const initialState = {
  user: null, // This will store user data
  isLoggedIn: false, // To track login status
  MedicalStore: null
};
export const fetchStore = (id) => async (dispatch) => {
  try {
    console.log(id)
    const response = await axios.get(`https://api.swasthmitra.com/api/stores/fetchstores/${id}`);
    dispatch(setMedical(response.data.store))
    console.log(response.data)
  } catch (error) {
    console.error('Error fetching store:', error);
  }
}

const UserSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
      // console.log("user", state.user)
      state.isLoggedIn = true;
    },
    clearUser(state) {
      state.user = null;
      state.MedicalStore = null;
      state.isLoggedIn = false;
    },
    setMedical(state, action) {
      state.MedicalStore = action.payload;
    }
  },
});

export const { setUser, clearUser, setMedical } = UserSlice.actions;

export const updateUserTokens = (userId, tokens) => async (dispatch) => {
  try {
    const response = await axios.put(`https://api.swasthmitra.com/api/users/update-tokens/${userId}`, {
      tokens
    });

    if (response.status === 200) {
      dispatch(setUser(response.data.user));
    }
  } catch (error) {
    console.error('Error updating tokens:', error);
  }
};

// New action to refresh user profile data
export const refreshUserProfile = (userId) => async (dispatch) => {
  try {
    const response = await axios.get(`https://api.swasthmitra.com/api/usermedical/user/${userId}`);
    
    if (response.status === 200 && response.data.user) {
      dispatch(setUser(response.data.user));
      return { success: true, user: response.data.user };
    }
  } catch (error) {
    console.error('Error refreshing user profile:', error);
    return { success: false, error: error.message };
  }
};

export default UserSlice.reducer;
